const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

function createRequestTypes(base) {
    const res = {};
    [REQUEST, SUCCESS, FAILURE].forEach(type => res[type] = `${base}_${type}`);
    return res;
}

function action(type, data = {}) {
    return {
        type,
        data
    };
}

export const GET_WITHDRAWAL_REQUESTS = createRequestTypes('GET_CALLBACK_ENQUIRIES');
export const GET_PENDING_ORDERS_COUNT = createRequestTypes('GET_PENDING_ORDERS_COUNT');

export const sagaActions = {
    get_callback_enquiries: {
        request: (data) => action(GET_WITHDRAWAL_REQUESTS.REQUEST, data),
        success: (data) => action(GET_WITHDRAWAL_REQUESTS.SUCCESS, data),
        failure: (data, error) => action(GET_WITHDRAWAL_REQUESTS.FAILURE)
    },
    get_pending_orders_count: {
        request: (data) => action(GET_PENDING_ORDERS_COUNT.REQUEST, data),
        success: (data) => action(GET_PENDING_ORDERS_COUNT.SUCCESS, data),
        failure: (data, error) => action(GET_PENDING_ORDERS_COUNT.FAILURE)
    }
};


// WEBPACK FOOTER //
// ./src/sagas/actions.js